const cartInfo = (cartInfo) => {
  return {
    type: "CART_INFO",
    payload: cartInfo,
  };
};

export default cartInfo;
